// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import MetadataField, { StatueValueType } from './metadata-field';

export default class StatusField extends MetadataField {
  static propTypes = {
    ...MetadataField.propTypes,
    ...MetadataField.StatusPropTypes,
    onStatusChange: PropTypes.func.isRequired,
    editing: PropTypes.bool.isRequired,
  };

  renderEditable() {
    const { styles } = StatusField;

    return (
      <select
        onChange={this.handleSelectChange}
        value={this.selectValue}
        className={css(styles.select)}
      >
        {this.renderOptions()}
      </select>
    );
  }

  get selectValue() {
    return this.props.statusValue?.value || '';
  }

  renderLabelContent() {
    return <strong className={MetadataField.styles.strong}>{this.statusLabel || 'Status'}</strong>;
  }

  renderValueContent() {
    return <span>{this.statusValue}</span>;
  }

  renderOptions() {
    const result = this.props.statusChoices.map((option: StatueValueType) => (
      <option
        key={option.value}
        value={option.value}
      >
        {option.label}
      </option>
    ));

    return result;
  }

  handleSelectChange = (event) => {
    const status = event.target.value.length ? event.target.value : null;

    this.props.onStatusChange(status);
  };

  get statusLabel() {
    return this.props.statusLabel || null;
  }

  get statusValue() {
    return this.props.statusValue?.label || null;
  }
}

const styles = cssInJS({
  select: {
    fontFamily: THEME.fontFamily,
    fontSize: THEME.editFontSize,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    display: 'inline-block',
    padding: 5,
    verticalAlign: 'middle',
    borderRadius: 5,
    width: '100%',
    marginTop: 4,
    marginRight: 0,
    marginBottom: 4,
    marginLeft: 0,
    // '-webkit-appearance': 'none',

    '@phone': {
      width: '100%',
    },
  },
});

StatusField.styles = styles;
